export const SexualOrientation = [
  {
    name: 'Straight/Heterosexual',
    value: 'heterosexual',
    translate_key: 'journey_gender_orientation_option_heterosexual'
  },
  {
    name: 'Homosexual, lesbian, gay',
    value: 'homosexual',
    translate_key: 'journey_gender_orientation_option_homosexual'
  },
  {
    name: 'Bisexual',
    value: 'bisexual',
    translate_key: 'journey_gender_orientation_option_bisexual'
  },
  {
    name: 'Prefer not to say',
    value: 'undisclosed',
    translate_key: 'journey_gender_orientation_option_undisclosed'
  },
];

export default SexualOrientation;